<template>
  <div class="col-lg-3 col-md-12 pull-right">
    <div class="row">
      <div class="col-lg-12 col-md-6">
        <div class="box box-danger box-solid collapsed-box">
          <div class="box-header with-border">
            <h3 class="box-title">Offene Bestellungen</h3>
            <div class="box-tools pull-right" title="Details einblenden">
              <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-plus"></i></button>
            </div>
          </div>
          <div class="info-box bg-danger-active no-margin">
            <span class="info-box-icon"><i class="fa fa-shopping-bag"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">389 Artikel</span>
              <span class="info-box-number">225 <small>Bestellungen</small></span>
            </div>
          </div>
          <div class="box-body" style="display: none;">
            <ul class="list-group list-group-unbordered">
              <li class="list-group-item">
                <b>Stornos Händler:</b> <span class="pull-right">7.440</span>
              </li>
              <li class="list-group-item">
                <b>Stornos schuhe.de:</b> <span class="pull-right">2.864</span>
              </li>
              <li class="list-group-item">
                <b>Stornos gesamt:</b> <span class="pull-right">10.304</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-md-6">
        <div class="box box-solid collapsed-box">
          <div class="box-header with-border">
            <h3 class="box-title">Click &amp; Collect</h3>
            <div class="box-tools pull-right" title="Details einblenden">
              <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-plus"></i></button>
            </div>
          </div>
          <div class="info-box no-margin">
            <span class="info-box-icon"><i class="fa fa-tags"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">&nbsp;</span>
              <span class="info-box-number">6.797 <small>Reservierungen</small></span>
            </div>
          </div>
          <div class="box-body" style="display: none;">
            <ul class="list-group list-group-unbordered">
              <li class="list-group-item">
                <b>Verkauft (33,5%):</b> <span class="pull-right">2.277</span>
              </li>
              <li class="list-group-item">
                <b>Dieser Monat:</b> <span class="pull-right">464</span>
              </li>
              <li class="list-group-item">
                <b>Letzter Monat:</b> <span class="pull-right">699</span>
              </li>
              <li class="list-group-item">
                <b>Heute:</b> <span class="pull-right">2</span>
              </li>
              <li class="list-group-item">
                <b>Gestern:</b> <span class="pull-right">12</span>
              </li>
              <li class="list-group-item">
                <b>Woche:</b> <span class="pull-right">70</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
    // TODO GET DATA FROM API
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/OpenAndCollectComponent.vue